import React from "react";
import { ColumnBodyOptions } from "primereact/column";
import { EllipsisCell2 } from "./EllipsisCell2.tsx";

// Dunno why eslint thinks this, even though this component is not exported :shrug:
// eslint-disable-next-line react-refresh/only-export-components
const LocalisedValue: React.FC<{
  value: Date | null | number | string | boolean | undefined;
}> = ({ value }) => {
  if (value === null || value === undefined) {
    return <span></span>;
  }
  if (value === true || value === false) {
    return value ? (
      <span>
        <i className="pi pi-check" />
      </span>
    ) : (
      <span>
        <i className="pi pi-times" />
      </span>
    );
  }
  if (typeof value === "string") {
    return <span>{value}</span>;
  }
  if (typeof value === "number") {
    return <span>{value.toLocaleString("pl-PL")}</span>;
  }
  if (value instanceof Date) {
    return <span>{value.toLocaleDateString("pl-PL")}</span>;
  }
  // Never will reach :)
  return <span>{value}</span>;
};

export const localisedValue = (
  data: Record<string, Date | null | number | string | boolean | undefined>,
  options: ColumnBodyOptions,
) => {
  const value = data[options.field];
  if (
    options.column.props.className?.includes("column--large") &&
    typeof value === "string" &&
    value !== ""
  ) {
    return (
      <EllipsisCell2 field={options.field} id={data.id as number}>
        <LocalisedValue value={value} />
      </EllipsisCell2>
    );
  }
  return <LocalisedValue value={value} />;
};
